import { discardSizePopup } from './instrumentation';
import { maternityGeneralItem } from './maternityWearData';

export const SelectSizeText = () => {
  return 'Select size';
};

export const initialValue = {
  productName: '',
  sectionName: '',
  sectionId: '',
  sellingPrice: '',
};

export const isInViewport = (el, showHeader, wrapHeight) => {
  var rect = el.getBoundingClientRect();
  const scrollDistance = window.scrollY;
  const offsetValue = showHeader ? 240 : 210;
  return (
    scrollDistance > el.offsetTop - offsetValue - wrapHeight &&
    scrollDistance < rect.height + el.offsetTop - offsetValue - wrapHeight
  );
};
let lastScrollTop = 0;
export const debounceFunction = (func, delay) => {
  let timer;
  return () => {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(func, delay);
  };
};
export const highlightOnScroll = (
  containerRef,
  chipsRef,
  showHeader,
  bottomRef,
  wrapHeight,
) => {
  const children = containerRef.current.children;
  const chips = chipsRef.current.children;
  if (window.scrollY >= bottomRef?.current.offsetTop) {
    chipsRef.current.scrollLeft += 500;
  }
  if (window.scrollY <= 200) {
    chipsRef.current.scrollLeft -= 500;
  }
  for (let i = 0; i < children.length; i++) {
    let child = children[i];
    if (isInViewport(child, showHeader, wrapHeight)) {
      for (let x = 0; x < chips.length; x++) {
        const chip = chips[x];
        if (!chip.classList.contains('active') && chip.id === child.id) {
          chips[0].classList.remove('active');
          chip.classList.add('active');
          let totalScroll = 0;
          for (let j = 0; j < chips.length; j++) {
            if (chips[j]?.id < chip.id)
              totalScroll += chips[j]?.getBoundingClientRect().width;
          }
          chipsRef.current.scrollTo({
            behavior: 'smooth',
            left: totalScroll,
          });
          // if (chip.id > chips?.[0]?.id) {
          //     let st =
          //         window.pageYOffset ||
          //         document.documentElement.scrollTop;
          //     if (st > lastScrollTop) {
          //         if (chip.id > chips?.[1]?.id) {
          //             chipsRef.current.scrollLeft += chip.scrollWidth;
          //         }
          //     } else if (st < lastScrollTop) {
          //         if (
          //             chip.id <= chips?.[4]?.id &&
          //             chip.id > chips[2]?.id
          //         ) {
          //             chipsRef.current.scrollLeft -= chip.scrollWidth;
          //         } else if (chip.id <= chips[2]?.id) {
          //             chipsRef.current.scrollLeft -=
          //                 chip.scrollWidth + 0.3 * window.innerWidth;
          //         }
          //     }
          //     lastScrollTop = st <= 0 ? 0 : st;
          // }
        }
      }
    } else {
      for (let x = 0; x < chips.length; x++) {
        const chip = chips[x];
        if (
          chip.classList.contains('active') &&
          chip.id === child.id &&
          chip.id !== '4091'
        )
          chip.classList.remove('active');
      }
    }
  }
};

export const closeSizeModal = (setShowSizePopup, router, skuName, skuId) => {
  discardSizePopup(skuName, skuId);
  popupBackHandler(setShowSizePopup);
  router.back();
};
export const popupBackHandler = (setShowSizePopup) => {
  setShowSizePopup(false);
  const params = new URLSearchParams(window.location.search);
  params.delete('sizepopup');
  document.getElementsByTagName('body')[0].classList.remove('noScroll');
};

export const navigateToPdpFromMD = (id, setFocusElement) => {
  setFocusElement(id);
  setTimeout(() => {
    setFocusElement(null);
  }, 250);
};

export const getProduct = (productId) => {
  maternityGeneralItem.map((itemSet) => {
    itemSet.items.map((item) => {
      if (item.product_id === productId) {
        return item;
      }
    });
  });
};

export const viewPortDescription =
  "Look and feel your best during pregnancy with Mylo's collection of maternity wear clothing. Our range includes maxi and midi length dresses, kaftans, and more, all designed to flatter your changing shape and keep you comfortable throughout your pregnancy. With a variety of styles and colors to choose from, you're sure to find the perfect outfit for any occasion. Plus, our maternity wear clothing is also great for post-pregnancy feeding. Shop now for comfortable, stylish maternity wear from Mylo.";
export const maternityHeading = 'MATERNITY WEAR';
